import { styled } from '@mui/system';
import { Box, Button, IconButton, Tooltip, Select } from '@mui/material';

export const ToolbarContainer = styled(Box)(({ theme, isSidebarOpen }) => ({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    padding: '10px 20px',
    color: '#111827',
    position: 'fixed',
    top: '60px',
    width: 'calc(100% - 100px)',
    transition: 'width 0.5s ease',
    zIndex: 1001,
    height: '75px',
    justifyContent: 'space-between',
    boxShadow: '0 2px 4px rgba(15, 23, 42, 0.06)',
    borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
    '& .MuiButton-root': {
        margin: theme.spacing(1),
    },
}));

export const ButtonSection = styled(Box)({
    display: 'flex',
    alignItems: 'center',
});

export const ButtonGroup = styled(Box)({
    display: 'flex',
    alignItems: 'center',
});

export const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: '30px',
    backgroundColor: '#3a3a3a',      // Negro por defecto
    color: '#fff',
    minWidth: '48px',
    fontSize: '11px',
    textTransform: 'none',
    '& .MuiButton-startIcon': {
        margin: '0',
    },
    '&:hover': {
        backgroundColor: '#565656',
    },
    '&:disabled': {
        backgroundColor: '#b6b6b6',
        color: '#888',
    },

    // Para el botón "Seleccionar análisis" (variant="outlined")
    '&.MuiButton-outlined': {
        backgroundColor: '#ffffff',
        color: '#3a3a3a',
        borderColor: '#3a3a3a',
        '&:hover': {
            backgroundColor: '#f3f4f6',
            borderColor: '#111827',
        },
    },
}));

export const IconButtonStyled = styled(IconButton)(({ theme, active }) => ({
    margin: theme.spacing(1),
    padding: 6,
    borderRadius: 999,
    color: active ? 'var(--primary-color)' : 'rgba(55, 65, 81, 0.9)',
    transition: 'background-color 0.2s ease, color 0.2s ease, transform 0.1s ease',
    '&:hover': {
        backgroundColor: active
            ? 'rgba(0, 0, 0, 0.04)'       // sutil, sin azul
            : 'rgba(148, 163, 184, 0.18)',
        transform: 'translateY(-1px)',
    },
    '&.Mui-disabled': {
        color: 'rgba(148, 163, 184, 0.9)',
    },
}));

export const TooltipStyled = styled(Tooltip)({});

export const StyledSelect = styled(Select)(({ theme }) => ({
    borderRadius: 999,
    backgroundColor: '#ffffff',
    color: '#111827',
    fontSize: '11px',
    minWidth: '120px',
    marginRight: '10px',
    boxShadow: '0 1px 3px rgba(15, 23, 42, 0.12)',

    '.MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(148, 163, 184, 0.6)',
    },

    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'var(--primary-color)',
    },

    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'var(--primary-color)',
        borderWidth: 1,
    },

    '& .MuiSvgIcon-root': {
        color: 'var(--primary-color)',
    },

    '& .MuiSelect-select': {
        padding: '6px 10px',
        display: 'flex',
        alignItems: 'center',
    },

    '&.Mui-disabled': {
        backgroundColor: 'rgba(148, 163, 184, 0.15)',
        color: 'rgba(107, 114, 128, 0.9)',
        '.MuiSvgIcon-root': {
            color: 'rgba(148, 163, 184, 0.9)',
        },
        '.MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(148, 163, 184, 0.5)',
        },
    },
}));
